import React from "react";
import { useEffect, useState } from "react";
import UIkit from "uikit";
import { useAuth } from "../../Context/AuthProvider";
import { url } from "../../Constant";
import { toast } from "react-toastify";
import axios from "axios";
import { ValidateEmail } from "../../Utils/regexFunctions";

const Profile = () => {
  const { auth } = useAuth();
  const [loader, setLoader] = useState(false);
  const [errorEnable, setErrorEnable] = useState(false);
  const [emailError, setEmailError] = useState("Valid Email Address");
  const [submittedData, setSubmittedData] = useState({
    company: auth.company_name,
    number: auth.work_number,
    email: auth.email,
  });
  useEffect(() => {
    var trVal = sessionStorage.getItem("ct_licked");
    UIkit.switcher("#renderSwitcher").show(trVal);
  }, []);

  const handleEmailValidation = (e) => {
    var Email = ValidateEmail(e.target.value);
    if (Email === "Invalid Email") {
      setEmailError("Invalid Email Address");
    } else {
      setEmailError("Valid Email Address");
    }
  };

  const updateProfile = (e) => {
    e.preventDefault();

    setErrorEnable(true);
    setLoader(true);

    var formData = new FormData();
    formData.append("company_name", submittedData.company);
    formData.append("email", submittedData.email);
    formData.append("vpbx_id", auth.vpbx_id);
    formData.append("work_number", submittedData.number);

    if (
      submittedData.company !== "" &&
      submittedData.email !== "" &&
      submittedData.number !== "" &&
      emailError === "Valid Email Address"
    ) {
      axios
        .post(url + "updateProfile", formData, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        })
        .then((response) => {
          if (response.data.code === 200) {
            if (response.data.message === "User Update Successfully") {
              setLoader(false);
              toast.success(response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1500,
              });
            } else {
              // If the message property is not as expected, show an error message
              toast.error("Unexpected response from the server", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1500,
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
          // Handle other errors (e.g., network errors)
          toast.error("An error occurred", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1500,
          });
        })
        .finally(() => {
          setLoader(false);
        });
    } else {
      setLoader(false);
    }
  };

  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-large">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <h3>PROFILE CONFIGRATION</h3>
              </div>
            </div>

            <div className="uk-width-1-1 ">
              <ul
                className="uk-subnav callSwitcher"
                id="renderSwitcher"
                uk-switcher="connect: .callClass"
              >
                <li onClick={() => sessionStorage.setItem("ct_licked", 0)}>
                  <a href="#">Profile</a>
                </li>
              </ul>
            </div>
          </div>
          <ul className="uk-switcher uk-margin callClass">
            <li>
              <div className="dashboardWrp">
                <div className="uk-container uk-container-small">
                  <div className="dashboardTop">
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-2-3">
                        <div className="dashboardIntro">
                          <h3>Profile Update</h3>
                        </div>
                      </div>
                    </div>

                    <form action="javascript:void(0);">
                      <div className="formCreateMain">
                        <div className="uk-grid uk-grid-small">
                          <div className="uk-width-1-2@m uk-margin-top">
                            <label>Company name</label>
                            <input
                              className="uk-input"
                              type="text"
                              aria-label="Input"
                              placeholder="Enter company name"
                              value={submittedData.company}
                              onChange={(e) => {
                                setSubmittedData({
                                  ...submittedData,
                                  company: e.target.value,
                                });
                              }}
                            />
                            {errorEnable && submittedData.company === "" && (
                              <div className="formErrors">
                                Company name is required
                              </div>
                            )}
                            {/* Company Name, Number, POC email and company logo can be changed. */}
                          </div>
                          <div className="uk-width-1-2@m uk-margin-top">
                            <label>Number </label>
                            <input
                              className="uk-input"
                              type="text"
                              aria-label="Input"
                              placeholder="Enter number"
                              value={submittedData.number}
                              onChange={(e) => {
                                setSubmittedData({
                                  ...submittedData,
                                  number: e.target.value,
                                });
                              }}
                            />
                            {errorEnable && submittedData.number === "" && (
                              <div className="formErrors">
                                Number is required
                              </div>
                            )}
                          </div>
                          <div className="uk-width-1-2@m uk-margin-top">
                            <label>Email </label>
                            <input
                              className="uk-input"
                              type="text"
                              aria-label="Input"
                              placeholder="Enter number email"
                              value={submittedData.email}
                              onChange={(e) => {
                                setSubmittedData({
                                  ...submittedData,
                                  email: e.target.value,
                                });
                                handleEmailValidation(e);
                              }}
                            />
                            {errorEnable && submittedData.email === "" && (
                              <div className="formErrors">
                                Email is required
                              </div>
                            )}
                            {submittedData.email !== "" &&
                              emailError !== "Valid Email Address" && (
                                <div className="uk-width-1-1 formErrors">
                                  Invalid Email Address
                                </div>
                              )}
                          </div>

                          <div className="uk-width-1-1@m uk-float-right uk-margin-top">
                            <div className="formActionBtn uk-text-right">
                              <button
                                className="pinkBtn"
                                onClick={updateProfile}
                              >
                                {loader ? (
                                  <div uk-spinner="" className="loader">
                                    Adding
                                  </div>
                                ) : (
                                  "Update"
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              {/* <CreateIVR /> */}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Profile;
